"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationsScreen = OrganizationsScreen;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var confirm_dialog_1 = require("../../components/common/confirm-dialog");
var data_table_1 = require("../../components/common/data-table");
var page_header_1 = require("../../components/common/page-header");
var permission_gate_1 = require("../../components/common/permission-gate");
var search_input_1 = require("../../components/common/search-input");
var status_badge_1 = require("../../components/common/status-badge");
var organizations_1 = require("../../features/apis/organizations");
var use_error_handler_1 = require("../../hooks/use-error-handler");
var use_permissions_1 = require("../../hooks/use-permissions");
var organization_1 = require("../../interfaces/organization");
var permissions_1 = require("../../interfaces/permissions");
function PlusIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4v16m8-8H4" }) }));
}
function OrganizationsScreen() {
    var _this = this;
    var _a, _b, _c;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var hasPermission = (0, use_permissions_1.usePermissions)().hasPermission;
    var _d = (0, use_error_handler_1.useErrorHandler)(), handleError = _d.handleError, handleSuccess = _d.handleSuccess;
    var _e = (0, react_2.useState)(1), page = _e[0], setPage = _e[1];
    var _f = (0, react_2.useState)(""), search = _f[0], setSearch = _f[1];
    var _g = (0, react_2.useState)(""), statusFilter = _g[0], setStatusFilter = _g[1];
    var _h = (0, react_1.useDisclosure)(), isFormOpen = _h.isOpen, onFormOpen = _h.onOpen, onFormClose = _h.onClose;
    var _j = (0, react_1.useDisclosure)(), isDeleteOpen = _j.isOpen, onDeleteOpen = _j.onOpen, onDeleteClose = _j.onClose;
    var _k = (0, react_2.useState)(null), editingOrg = _k[0], setEditingOrg = _k[1];
    var _l = (0, react_2.useState)(null), deletingOrg = _l[0], setDeletingOrg = _l[1];
    // Form state
    var _m = (0, react_2.useState)({
        name: "",
        code: "",
        status: organization_1.EOrganizationStatus.ACTIVE,
    }), formData = _m[0], setFormData = _m[1];
    var _o = (0, organizations_1.useGetOrganizationsQuery)({
        page: page,
        limit: 10,
        search: search || undefined,
        status: statusFilter || undefined,
    }), data = _o.data, isLoading = _o.isLoading, isFetching = _o.isFetching;
    var _p = (0, organizations_1.useCreateOrganizationMutation)(), createOrganization = _p[0], isCreating = _p[1].isLoading;
    var _q = (0, organizations_1.useUpdateOrganizationMutation)(), updateOrganization = _q[0], isUpdating = _q[1].isLoading;
    var _r = (0, organizations_1.useDeleteOrganizationMutation)(), deleteOrganization = _r[0], isDeleting = _r[1].isLoading;
    var _s = (0, organizations_1.useEnableOrganizationMutation)(), enableOrganization = _s[0], isEnabling = _s[1].isLoading;
    var _t = (0, organizations_1.useDisableOrganizationMutation)(), disableOrganization = _t[0], isDisabling = _t[1].isLoading;
    var organizations = ((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.organizations) || [];
    var totalPages = ((_c = (_b = data === null || data === void 0 ? void 0 : data.content) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.total_pages) || 1;
    var columns = [
        {
            key: "name",
            label: "Name",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "font-medium text-foreground", children: item.name }); },
        },
        {
            key: "code",
            label: "Code",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: item.code }); },
        },
        {
            key: "status",
            label: "Status",
            render: function (item) { return (0, jsx_runtime_1.jsx)(status_badge_1.StatusBadge, { status: item.status }); },
        },
        {
            key: "created_at",
            label: "Created",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: new Date(item.created_at).toLocaleDateString("en-ZA", { timeZone: "Africa/Johannesburg" }) }); },
        },
        {
            key: "actions",
            label: "Actions",
            align: "end",
            render: function (item) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", onPress: function () { return navigate("/organizations/".concat(item._id)); }, children: "View" }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.ORGANIZATIONS, action: permissions_1.ACTIONS.UPDATE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "primary", onPress: function () { return handleEdit(item); }, children: "Edit" }) }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.ORGANIZATIONS, action: permissions_1.ACTIONS.UPDATE, children: item.status === "active" ? ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "warning", isLoading: isDisabling, onPress: function () { return handleToggleStatus(item, false); }, children: "Disable" })) : ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "success", isLoading: isEnabling, onPress: function () { return handleToggleStatus(item, true); }, children: "Enable" })) }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.ORGANIZATIONS, action: permissions_1.ACTIONS.DELETE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "danger", onPress: function () { return handleDeleteClick(item); }, children: "Delete" }) })] })); },
        },
    ];
    var handleCreate = function () {
        setEditingOrg(null);
        setFormData({ name: "", code: "", status: organization_1.EOrganizationStatus.ACTIVE });
        onFormOpen();
    };
    var handleEdit = function (org) {
        setEditingOrg(org);
        setFormData({
            name: org.name,
            code: org.code,
            status: org.status,
        });
        onFormOpen();
    };
    var handleDeleteClick = function (org) {
        setDeletingOrg(org);
        onDeleteOpen();
    };
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Validate required fields
                    if (!formData.name.trim()) {
                        handleError(new Error("Organization name is required"), {
                            defaultMessage: "Please enter an organization name",
                        });
                        return [2 /*return*/];
                    }
                    if (!editingOrg && !formData.code.trim()) {
                        handleError(new Error("Organization code is required"), {
                            defaultMessage: "Please enter an organization code",
                        });
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!editingOrg) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateOrganization({
                            id: editingOrg._id,
                            data: {
                                name: formData.name.trim(),
                                status: formData.status,
                            },
                        }).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("Organization updated successfully");
                    return [3 /*break*/, 5];
                case 3: 
                // Only send fields that are in ICreateOrganization interface
                return [4 /*yield*/, createOrganization({
                        name: formData.name.trim(),
                        code: formData.code.trim().toUpperCase(),
                    }).unwrap()];
                case 4:
                    // Only send fields that are in ICreateOrganization interface
                    _a.sent();
                    handleSuccess("Organization created successfully");
                    _a.label = 5;
                case 5:
                    onFormClose();
                    // Reset form after successful submission
                    setFormData({ name: "", code: "", status: organization_1.EOrganizationStatus.ACTIVE });
                    setEditingOrg(null);
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    handleError(error_1, {
                        defaultMessage: editingOrg ? "Failed to update organization" : "Failed to create organization",
                    });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!deletingOrg)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteOrganization(deletingOrg._id).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("Organization deleted successfully");
                    onDeleteClose();
                    setDeletingOrg(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    handleError(error_2, {
                        defaultMessage: "Failed to delete organization",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleToggleStatus = function (org, enable) { return __awaiter(_this, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!enable) return [3 /*break*/, 2];
                    return [4 /*yield*/, enableOrganization(org._id).unwrap()];
                case 1:
                    _a.sent();
                    handleSuccess("Organization \"".concat(org.name, "\" enabled successfully"));
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, disableOrganization(org._id).unwrap()];
                case 3:
                    _a.sent();
                    handleSuccess("Organization \"".concat(org.name, "\" disabled successfully"));
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_3 = _a.sent();
                    handleError(error_3, { defaultMessage: "Failed to ".concat(enable ? "enable" : "disable", " organization") });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Build actions array conditionally based on permissions
    var headerActions = [];
    if (hasPermission(permissions_1.MODULES.ORGANIZATIONS, permissions_1.ACTIONS.CREATE)) {
        headerActions.push({
            label: "Add Organization",
            icon: (0, jsx_runtime_1.jsx)(PlusIcon, {}),
            onClick: handleCreate,
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsx)(page_header_1.PageHeader, { title: "Organizations", description: "Manage dealers and organizations", actions: headerActions }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-4", children: [(0, jsx_runtime_1.jsx)(search_input_1.SearchInput, { placeholder: "Search organizations...", value: search, onChange: setSearch, className: "w-64" }), (0, jsx_runtime_1.jsxs)("select", { value: statusFilter, onChange: function (e) { return setStatusFilter(e.target.value); }, className: "h-8 w-40 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "All Statuses" }), (0, jsx_runtime_1.jsx)("option", { value: "active", children: "Active" }), (0, jsx_runtime_1.jsx)("option", { value: "inactive", children: "Inactive" })] })] }), (0, jsx_runtime_1.jsx)(data_table_1.DataTable, { columns: columns, data: organizations, isLoading: isLoading || isFetching, page: page, totalPages: totalPages, onPageChange: setPage, onRowClick: function (item) { return navigate("/organizations/".concat(item._id)); }, emptyContent: "No organizations found" }), (0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isFormOpen, onClose: onFormClose, size: "md", isDismissable: !isCreating && !isUpdating, hideCloseButton: isCreating || isUpdating, disableAnimation: true, children: (0, jsx_runtime_1.jsx)(react_1.ModalContent, { children: function (onClose) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.ModalHeader, { children: editingOrg ? "Edit Organization" : "Create Organization" }), (0, jsx_runtime_1.jsx)(react_1.ModalBody, { children: (0, jsx_runtime_1.jsx)("form", { id: "organization-form", onSubmit: function (e) {
                                        e.preventDefault();
                                        handleSubmit();
                                    }, children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Name", placeholder: "Enter organization name", value: formData.name, onValueChange: function (value) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { name: value })); }); }, isRequired: true }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Code", placeholder: "Enter organization code", value: formData.code, onValueChange: function (value) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { code: value.toUpperCase() })); }); }, isRequired: true, isDisabled: !!editingOrg }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { className: "mb-1.5 block text-sm text-default-600", children: "Status" }), (0, jsx_runtime_1.jsxs)("select", { value: formData.status, onChange: function (e) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { status: e.target.value })); }); }, className: "w-full rounded-lg border border-default-300 bg-default-100 px-3 py-2.5 text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary focus:ring-2 focus:ring-primary/20", children: [(0, jsx_runtime_1.jsx)("option", { value: organization_1.EOrganizationStatus.ACTIVE, children: "Active" }), (0, jsx_runtime_1.jsx)("option", { value: organization_1.EOrganizationStatus.INACTIVE, children: "Inactive" })] })] })] }) }) }), (0, jsx_runtime_1.jsxs)(react_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "bordered", onPress: onClose, isDisabled: isCreating || isUpdating, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", onPress: handleSubmit, isLoading: isCreating || isUpdating, isDisabled: !formData.name.trim() || (!editingOrg && !formData.code.trim()) || isCreating || isUpdating, children: editingOrg ? "Update" : "Create" })] })] })); } }) }), (0, jsx_runtime_1.jsx)(confirm_dialog_1.ConfirmDialog, { isOpen: isDeleteOpen, onClose: onDeleteClose, onConfirm: handleDelete, title: "Delete Organization", message: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Are you sure you want to permanently delete ", (0, jsx_runtime_1.jsx)("strong", { children: deletingOrg === null || deletingOrg === void 0 ? void 0 : deletingOrg.name }), "? This action cannot be undone.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-default-400", children: "Note: Organizations with associated users or orders cannot be deleted. Use \"Disable\" to deactivate the organization instead." })] }), confirmLabel: "Delete Permanently", confirmColor: "danger", isLoading: isDeleting })] }));
}
